import React from 'react';
import {Link, NavLink, Route, Routes} from "react-router-dom";
import {withRouter} from "../withRouter";

class Subscriptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            subscriptions: [],
            games: [],
            isSubscriptionsLoaded: false,
        };
    }

    componentDidMount() {
        console.log(JSON.stringify(this.props));
        if(this.props.userId) {
            fetch(process.env.REACT_APP_API_URL + "/customer/" + this.props.userId.toString() + "/subscriptions", {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        console.log(result);
                        this.setState({
                            isSubscriptionsLoaded: true,
                            subscriptions: result.subscriptions,
                            games: result.games,
                        });
                    },

                    (error) => {
                        console.log(error);

                        this.setState({
                            isLoadedSubscriptions: true,
                            error
                        });
                    }
                )
        }
    }

    render() {
        const { isSubscriptionsLoaded, subscriptions, games } = this.state;
        let subscriptionsFormatted = [];
        let gamesFormatted = [];

        if (!isSubscriptionsLoaded) {
            subscriptionsFormatted = <div>Loading...</div>;
        } else {
            subscriptionsFormatted = (
                subscriptions.map(item => (
                                <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                                    <i className="fab fa-github fa-lg" style={{color: "#333333"}}></i>
                                    <p className="mb-0">
                                        <NavLink
                                            to={"/publishers/" + item.publisher.id} class="btn btn-outline-dark"
                                        >
                                            {item.publisher.name}
                                        </NavLink>
                                    </p>
                                </li>
                )));
        }

        if (!isSubscriptionsLoaded) {
            gamesFormatted = <div>Loading...</div>;
        } else {
            gamesFormatted = this.props.loadGames ?
                games.map(item => (
                                    <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                                        <i className="fab fa-github fa-lg" style={{color: "#333333"}}></i>
                                        <p className="mb-0">
                                            <NavLink
                                                to={"/games/" + item.id}
                                                class="btn btn-outline-success"
                                            >
                                                <img width="80" style={{
                                                    borderRadius: 5
                                                }} src={item.game_page ? item.game_page.icon_url : "#"}></img>
                                                {item.name}
                                            </NavLink>
                                        </p>
                                    </li>
                                )) : '';
        }

        return <div className="card mb-4 mb-lg-0">
                    <div className="card-body p-0">
                        <ul className="list-group list-group-flush rounded-3">
                            {subscriptionsFormatted}
                            {gamesFormatted}
                        </ul>
                    </div>
                </div>;
    }
}

export default withRouter(Subscriptions);
